const FirestoreTimestampToDate = ({ seconds, nanoseconds }) => {
  const milliseconds = seconds * 1000 + nanoseconds / 1000000; // Convert to milliseconds
  const date = new Date(milliseconds);
  const formattedTime = date.toLocaleString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return <p>{formattedTime}</p>;
};

export default FirestoreTimestampToDate;
